/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Wealthlane_AwardService_Dtos_VestingTranche_VestingTrancheAddUpdateResponseDto } from '../models/Wealthlane_AwardService_Dtos_VestingTranche_VestingTrancheAddUpdateResponseDto';
import type { Wealthlane_AwardService_Dtos_VestingTranche_VestingTrancheImportParseDto } from '../models/Wealthlane_AwardService_Dtos_VestingTranche_VestingTrancheImportParseDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class VestingTrancheLegacyService {

    /**
     * @param requestType 
     * @param tenantId 
     * @param userId 
     * @param taskId 
     * @param requestBody 
     * @returns Wealthlane_AwardService_Dtos_VestingTranche_VestingTrancheAddUpdateResponseDto OK
     * @throws ApiError
     */
    public static postApiAwardApiAppVestingTrancheLegacyProcessAddUpdateVestingTranche(
requestType?: number,
tenantId?: string,
userId?: string,
taskId?: string,
requestBody?: Array<Wealthlane_AwardService_Dtos_VestingTranche_VestingTrancheImportParseDto>,
): CancelablePromise<Wealthlane_AwardService_Dtos_VestingTranche_VestingTrancheAddUpdateResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/vesting-tranche-legacy/process-add-update-vesting-tranche',
            query: {
                'RequestType': requestType,
                'TenantId': tenantId,
                'userId': userId,
                'taskId': taskId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
